/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Suggestions_Unplaceable_HintInputs */



/**
* | output |
* | --- |
* | "These suggestions reference parts of the document that have since changed, so they can't be shown. Ask the AI to look at the document again and re-suggest." |
*
* @param {Suggestions_Unplaceable_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const suggestions_unplaceable_hint = /** @type {((inputs?: Suggestions_Unplaceable_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Suggestions_Unplaceable_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Diese Vorschläge beziehen sich auf Teile des Dokuments, die sich inzwischen geändert haben, und können daher nicht angezeigt werden. Bitte die KI, das Dokument erneut anzusehen und neue Vorschläge zu machen.")
	return /** @type {LocalizedString} */ ("These suggestions reference parts of the document that have since changed, so they can't be shown. Ask the AI to look at the document again and re-suggest.")
});